import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0 p-p-0" }
const _hoisted_3 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_4 = { class: "p-col-12 p-p-0" }
const _hoisted_5 = {
  key: 1,
  class: "p-d-flex p-flex-column p-m-0"
}
const _hoisted_6 = { class: "p-d-flex p-flex-row kn-flex p-p-0 p-m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KpiDocumentDesignerTypeCard = _resolveComponent("KpiDocumentDesignerTypeCard")
  const _component_KpiDocumentDesignerDocumentTypeCard = _resolveComponent("KpiDocumentDesignerDocumentTypeCard")
  const _component_KpiDocumentDesignerKpiListCard = _resolveComponent("KpiDocumentDesignerKpiListCard")
  const _component_KpiDocumentDesignerScorecardsListCard = _resolveComponent("KpiDocumentDesignerScorecardsListCard")
  const _component_KpiDocumentDesignerStyleCard = _resolveComponent("KpiDocumentDesignerStyleCard")
  const _component_KpiDocumentDesignerOptionsCard = _resolveComponent("KpiDocumentDesignerOptionsCard")
  const _component_KpiDocumentDesignerSaveDialog = _resolveComponent("KpiDocumentDesignerSaveDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiDocumentDesigner.title')), 1)
            ]),
            end: _withCtx(() => [
              _createVNode(_component_Button, {
                icon: "pi pi-save",
                class: "p-button-text p-button-rounded p-button-plain",
                disabled: _ctx.saveButtonDisabled,
                onClick: _ctx.saveKpi
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_Button, {
                icon: "pi pi-times",
                class: "p-button-text p-button-rounded p-button-plain",
                onClick: _ctx.closeKpi
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                class: "kn-progress-bar",
                mode: "indeterminate",
                "data-test": "progress-bar"
              }))
            : _createCommentVNode("", true),
          (_ctx.kpiDesigner)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                (_ctx.showScorecards)
                  ? (_openBlock(), _createBlock(_component_KpiDocumentDesignerTypeCard, {
                      key: 0,
                      class: "kn-flex",
                      chartType: _ctx.kpiDesigner.chart.type,
                      onTypeChanged: _ctx.onTypeChanged
                    }, null, 8, ["chartType", "onTypeChanged"]))
                  : _createCommentVNode("", true),
                (_ctx.kpiDesigner.chart.type === 'kpi')
                  ? (_openBlock(), _createBlock(_component_KpiDocumentDesignerDocumentTypeCard, {
                      key: 1,
                      class: "kn-flex",
                      propChart: _ctx.kpiDesigner.chart
                    }, null, 8, ["propChart"]))
                  : _createCommentVNode("", true),
                (_ctx.kpiDesigner.chart.type === 'kpi')
                  ? (_openBlock(), _createBlock(_component_KpiDocumentDesignerKpiListCard, {
                      key: 2,
                      class: "kn-flex",
                      propData: _ctx.kpiDesigner.chart.data,
                      kpiList: _ctx.kpiList,
                      documentType: _ctx.kpiDesigner.chart.model
                    }, null, 8, ["propData", "kpiList", "documentType"]))
                  : (_openBlock(), _createBlock(_component_KpiDocumentDesignerScorecardsListCard, {
                      key: 3,
                      class: "kn-flex",
                      propData: _ctx.kpiDesigner.chart.data,
                      scorecardList: _ctx.scorecards,
                      onScorecardChanged: _ctx.onScorecardChanged
                    }, null, 8, ["propData", "scorecardList", "onScorecardChanged"])),
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_KpiDocumentDesignerStyleCard, {
                    class: "kn-flex",
                    propStyle: _ctx.kpiDesigner.chart.style
                  }, null, 8, ["propStyle"]),
                  (_ctx.kpiDesigner.chart.type === 'kpi')
                    ? (_openBlock(), _createBlock(_component_KpiDocumentDesignerOptionsCard, {
                        key: 0,
                        class: "kn-flex",
                        propOptions: _ctx.kpiDesigner.chart.options
                      }, null, 8, ["propOptions"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_KpiDocumentDesignerSaveDialog, {
      visible: _ctx.saveDialogVisible,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveDialogVisible = false)),
      onSaveKpi: _ctx.onKpiSave
    }, null, 8, ["visible", "onSaveKpi"])
  ]))
}